import { Dispatch } from 'redux'
import { storeDispatchTypes } from "../../store/storeDispatchTypes"
import { RootState } from "../../store/rootReducer"
import { apiInstance } from "../../api/apiInstance"
import anchor from '../../../constants/anchor'

const searchCarListModels = (
    searchTerm: string,
    markId?: string
) => async (
    dispatch: Dispatch,
    getState: () => RootState,
): Promise<void> => {
    const { userData } = getState()
    const params = {
        userId:  userData.smsAuth.userId,
        search: searchTerm,
        ...(markId && { markId }),
    }
    const config = {
        headers: { Authorization: `${anchor} ${localStorage.getItem('accessToken')}` }
    }
    try {
        const { data: { status, models } } = await apiInstance.post('/getCarsSelectSearchModel', params, config)
        if (status === 'ok') {
            dispatch({
                type: storeDispatchTypes.setModelsCars,
                value: {
                    models
                }
            })
        }
    } catch (e) {
        console.error('load cars models failed', e)
    }
}

export default searchCarListModels
